import { createWithI18n } from '@post-office/placement-common-v2/i18n';
import { messagesLoader as jiraEmpanada} from '@post-office/team-package--i18n--jira-empanada';

export const withI18n = createWithI18n(jiraEmpanada);